import { useState } from 'react';
import { useSelector } from 'react-redux';
import { FaUser, FaCog } from 'react-icons/fa';
import AccountInfo from './accountInfo';
import Settings from './settings';
import AvatarUpload from './avatarUpload';

const tabs = [
  { name: 'Account Info', icon: <FaUser />, component: <AccountInfo /> },
  { name: 'Settings', icon: <FaCog />, component: <Settings /> },
];

const ProfilePage = () => {
  const user = useSelector((state) => state.user.user);
  const [activeTab, setActiveTab] = useState('Account Info');

  const currentTab = tabs.find((tab) => tab.name === activeTab);

  if (!user) {
    return <p className="text-gray-500">Loading...</p>;
  }

  return (
    <div className="w-full flex-grow flex flex-col">
      <div className="w-full max-w-5xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row items-center gap-4 mb-6">
          <AvatarUpload />
          <div>
            <h2 className="text-2xl font-semibold">{user.fullName}</h2>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex overflow-x-auto space-x-4 mb-6 border-b pb-2">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              onClick={() => setActiveTab(tab.name)}
              className={`flex items-center gap-2 px-4 py-2 whitespace-nowrap rounded-md transition ${
                activeTab === tab.name
                  ? 'bg-blue-100 text-blue-600 font-medium'
                  : 'text-gray-600 hover:text-blue-500'
              }`}
            >
              {tab.icon}
              {tab.name}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-lg shadow p-4">{currentTab.component}</div>
      </div>
    </div>
  );
}

export default ProfilePage;